import styles from './SubscriptionExpired.css'
import {Modal} from 'react-bootstrap'

class SubscriptionExpiredModal extends React.Component {
  render () {
    let {onHide, showModal} = this.props
    return (
      <Modal
        onHide={onHide}
        show={showModal}
        dialogClassName={`${styles.dialog} ${styles['subscription-expired']} modal-dialog`}>
        <Modal.Header id={styles['header-expired']}>
          <button onClick={onHide}
            type='button'
            className='close'
            data-dismiss='modal'
            aria-label='Close'>
            <span aria-hidden='true'>
              &times;
            </span>
          </button>
          <Modal.Title className={styles['title-modal']}>
            Subscription Expired
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            Your subscription has expired. Please extend your subscription to reactivate the account.
          </div>
        </Modal.Body>
        <Modal.Footer bsClass={`modal-footer ${styles.footer}  ${styles['subscription-expired']} `}>
          <div>
            <button
              type='button'
              className='btn btn-default'
              onClick={onHide}>
              Close
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

SubscriptionExpiredModal.propTypes = {
  onHide: React.PropTypes.func,
  showModal: React.PropTypes.bool
}

export default SubscriptionExpiredModal



// WEBPACK FOOTER //
// ./app/components/SubscriptionExpiredModal/SubscriptionExpiredModal.js